import type { ReactFlowInstance } from '@xyflow/react'
import { createContext } from 'react'

export const ReactFlowContext = createContext<ReactFlowInstance | null>(null)
